<template>
	<section class="section container" :class="`section--${shadeMode}`">
		<div class="row" :class="content.alignment === true ? 'reversed' : ''">
			<div class="col-xs-12"
					 :class="`col-lg-${leftColumnWidth || 6}`">
				<div class="section__text">
					<home-mainheading v-if="content.isTopBlock === true && content.extraTitle !== null"
														:big="content.title"
														:small="content.extraTitle" />
					<home-heading v-else-if="content.title !== null"
												:content="content.title" />
					<home-subheading v-if="content.subtitle"
													 :content="content.subtitle" />
					<div v-if="sectionText != null">
						<PortableText :value="sectionText"></PortableText>
					</div>
					<home-button v-if="content.button.slug && content.buttonText != null" :specific="content.buttonText" :default="content.button.text" :slug="content.button.slug" />
				</div>
			</div>
			<div class="col-xs-12"
					 :class="`col-lg-${rightColumnWidth || 6}`">
				<div class="section__visual">
					<autoplay-video v-if="content.singleVideo !== null"
													class="section__video"
													:content="content.singleVideo" />
					<img v-if="content.image && sectionImageAlt != null"
							 :src="$urlFor(content.image.asset.url, 1000)"
							 :alt="sectionImageAlt"
							 loading="lazy"
							 :width="content.image.asset.metadata.dimensions.width"
							 :height="content.image.asset.metadata.dimensions.height"
							 sizes="sm:100vw md:50vw lg:600px"/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import {useI18n, useLocalePath} from '#imports'
import {PortableText } from '@portabletext/vue'
const { locale } = useI18n()
const localePath = useLocalePath()
import { computed } from 'vue'
const props = defineProps({
	content: Object
})
let sectionText
let sectionImageAlt
let leftColumnWidth
let rightColumnWidth
let shadeMode = props.content.isDarkMode === true ? 'dark' : 'light'
if(props.content.text !== null) {
	sectionText = computed(() => locale.value === 'en' ? props.content.text.en : props.content.text.jp);
}
if(props.content.alt !== null) {
	sectionImageAlt = computed(() => locale.value === 'en' ? props.content.alt.en : props.content.alt.jp);
}
if(props.content.columnRatio !== null) {
	let ratio = props.content.columnRatio.columnRatio
	leftColumnWidth = ratio.charAt(0);
	rightColumnWidth = ratio.charAt(2);
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.section {
	justify-content: space-between;
	padding: 1rem;
	@include v.respond-to('small') {
		padding: 3rem;
	}
	.reversed {
		flex-direction: row-reverse;
		justify-content: space-between;
		.section__text {
			margin: 0;
			@include v.respond-to('small') {
				margin: 0 0 0 3rem;
			}
		}
	}
	&__text {
		margin: 0;
		@include v.respond-to('small') {
			margin: 0 3rem 0 0;
		}
	}
	&__visual {
		height: 100%;
		img {
			display: block;
			height: 100%;
			object-fit: cover;
			width: 100%;
		}
	}
	&__video {
		box-shadow: 0 0 5px rgba(200,200,200,0.5);
		margin: 2rem 0 0 0;
		width: 100%;
		@include v.respond-to('small') {
			margin: 0;
		}
		.video__container {
			margin: 0 !important;
		}
	}
}
</style>
